// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { List } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    publicGetConfConfig (params?: {}): Promise<List>;
    publicGetConfPubActionObject (params?: {}): Promise<List>;
    publicGetConfPubActionObjectDetail (params?: {}): Promise<List>;
    publicGetConfPubMapObject (params?: {}): Promise<List>;
    publicGetConfPubMapObjectDetail (params?: {}): Promise<List>;
    publicGetConfPubMapCurrencyDetail (params?: {}): Promise<List>;
    publicGetConfPubMapCurrencySym (params?: {}): Promise<List>;
    publicGetConfPubMapCurrencyLabel (params?: {}): Promise<List>;
    publicGetConfPubMapCurrencyUnit (params?: {}): Promise<List>;
    publicGetConfPubMapCurrencyUndl (params?: {}): Promise<List>;
    publicGetConfPubMapCurrencyPool (params?: {}): Promise<List>;
    publicGetConfPubMapCurrencyExplorer (params?: {}): Promise<List>;
    publicGetConfPubMapCurrencyTxFee (params?: {}): Promise<List>;
    publicGetConfPubMapTxMethod (params?: {}): Promise<List>;
    publicGetConfPubListObject (params?: {}): Promise<List>;
    publicGetConfPubListObjectDetail (params?: {}): Promise<List>;
    publicGetConfPubListCurrency (params?: {}): Promise<List>;
    publicGetConfPubListPairExchange (params?: {}): Promise<List>;
    publicGetConfPubListPairMargin (params?: {}): Promise<List>;
    publicGetConfPubListPairFutures (params?: {}): Promise<List>;
    publicGetConfPubListCompetitions (params?: {}): Promise<List>;
    publicGetConfPubInfoObject (params?: {}): Promise<List>;
    publicGetConfPubInfoObjectDetail (params?: {}): Promise<List>;
    publicGetConfPubInfoPair (params?: {}): Promise<List>;
    publicGetConfPubInfoPairFutures (params?: {}): Promise<List>;
    publicGetConfPubInfoTxStatus (params?: {}): Promise<List>;
    publicGetConfPubFees (params?: {}): Promise<List>;
    publicGetPlatformStatus (params?: {}): Promise<List>;
    publicGetTickers (params?: {}): Promise<List>;
    publicGetTickerSymbol (params?: {}): Promise<List>;
    publicGetTickersHist (params?: {}): Promise<List>;
    publicGetTradesSymbolHist (params?: {}): Promise<List>;
    publicGetBookSymbolPrecision (params?: {}): Promise<List>;
    publicGetBookSymbolP0 (params?: {}): Promise<List>;
    publicGetBookSymbolP1 (params?: {}): Promise<List>;
    publicGetBookSymbolP2 (params?: {}): Promise<List>;
    publicGetBookSymbolP3 (params?: {}): Promise<List>;
    publicGetBookSymbolR0 (params?: {}): Promise<List>;
    publicGetStats1KeySizeSymbolSideSection (params?: {}): Promise<List>;
    publicGetStats1KeySizeSymbolSideLast (params?: {}): Promise<List>;
    publicGetStats1KeySizeSymbolSideHist (params?: {}): Promise<List>;
    publicGetStats1KeySizeSymbolSection (params?: {}): Promise<List>;
    publicGetStats1KeySizeSymbolLast (params?: {}): Promise<List>;
    publicGetStats1KeySizeSymbolHist (params?: {}): Promise<List>;
    publicGetStats1KeySizeSymbolLongLast (params?: {}): Promise<List>;
    publicGetStats1KeySizeSymbolLongHist (params?: {}): Promise<List>;
    publicGetStats1KeySizeSymbolShortLast (params?: {}): Promise<List>;
    publicGetStats1KeySizeSymbolShortHist (params?: {}): Promise<List>;
    publicGetCandlesTradeTimeframeSymbolPeriodSection (params?: {}): Promise<List>;
    publicGetCandlesTradeTimeframeSymbolSection (params?: {}): Promise<List>;
    publicGetCandlesTradeTimeframeSymbolLast (params?: {}): Promise<List>;
    publicGetCandlesTradeTimeframeSymbolHist (params?: {}): Promise<List>;
    publicGetStatusType (params?: {}): Promise<List>;
    publicGetStatusDeriv (params?: {}): Promise<List>;
    publicGetStatusDerivSymbolHist (params?: {}): Promise<List>;
    publicGetLiquidationsHist (params?: {}): Promise<List>;
    publicGetRankingsKeyTimeframeSymbolSection (params?: {}): Promise<List>;
    publicGetRankingsKeyTimeframeSymbolHist (params?: {}): Promise<List>;
    publicGetPulseHist (params?: {}): Promise<List>;
    publicGetPulseProfileNickname (params?: {}): Promise<List>;
    publicGetFundingStatsSymbolHist (params?: {}): Promise<List>;
    publicGetExtVasps (params?: {}): Promise<List>;
    publicPostCalcTradeAvg (params?: {}): Promise<List>;
    publicPostCalcFx (params?: {}): Promise<List>;
    privatePostAuthRWallets (params?: {}): Promise<List>;
    privatePostAuthRWalletsHist (params?: {}): Promise<List>;
    privatePostAuthROrders (params?: {}): Promise<List>;
    privatePostAuthROrdersSymbol (params?: {}): Promise<List>;
    privatePostAuthWOrderSubmit (params?: {}): Promise<List>;
    privatePostAuthWOrderUpdate (params?: {}): Promise<List>;
    privatePostAuthWOrderCancel (params?: {}): Promise<List>;
    privatePostAuthWOrderMulti (params?: {}): Promise<List>;
    privatePostAuthWOrderCancelMulti (params?: {}): Promise<List>;
    privatePostAuthROrdersSymbolHist (params?: {}): Promise<List>;
    privatePostAuthROrdersHist (params?: {}): Promise<List>;
    privatePostAuthROrderSymbolIdTrades (params?: {}): Promise<List>;
    privatePostAuthRTradesSymbolHist (params?: {}): Promise<List>;
    privatePostAuthRTradesHist (params?: {}): Promise<List>;
    privatePostAuthRLedgersCurrencyHist (params?: {}): Promise<List>;
    privatePostAuthRLedgersHist (params?: {}): Promise<List>;
    privatePostAuthRInfoMarginKey (params?: {}): Promise<List>;
    privatePostAuthRInfoMarginBase (params?: {}): Promise<List>;
    privatePostAuthRInfoMarginSymAll (params?: {}): Promise<List>;
    privatePostAuthRPositions (params?: {}): Promise<List>;
    privatePostAuthWPositionClaim (params?: {}): Promise<List>;
    privatePostAuthWPositionIncrease (params?: {}): Promise<List>;
    privatePostAuthRPositionIncreaseInfo (params?: {}): Promise<List>;
    privatePostAuthRPositionsHist (params?: {}): Promise<List>;
    privatePostAuthRPositionsAudit (params?: {}): Promise<List>;
    privatePostAuthRPositionsSnap (params?: {}): Promise<List>;
    privatePostAuthWDerivCollateralSet (params?: {}): Promise<List>;
    privatePostAuthWDerivCollateralLimits (params?: {}): Promise<List>;
    privatePostAuthRFundingOffers (params?: {}): Promise<List>;
    privatePostAuthRFundingOffersSymbol (params?: {}): Promise<List>;
    privatePostAuthWFundingOfferSubmit (params?: {}): Promise<List>;
    privatePostAuthWFundingOfferCancel (params?: {}): Promise<List>;
    privatePostAuthWFundingOfferCancelAll (params?: {}): Promise<List>;
    privatePostAuthWFundingClose (params?: {}): Promise<List>;
    privatePostAuthWFundingAuto (params?: {}): Promise<List>;
    privatePostAuthWFundingKeep (params?: {}): Promise<List>;
    privatePostAuthRFundingOffersSymbolHist (params?: {}): Promise<List>;
    privatePostAuthRFundingOffersHist (params?: {}): Promise<List>;
    privatePostAuthRFundingLoans (params?: {}): Promise<List>;
    privatePostAuthRFundingLoansHist (params?: {}): Promise<List>;
    privatePostAuthRFundingLoansSymbol (params?: {}): Promise<List>;
    privatePostAuthRFundingLoansSymbolHist (params?: {}): Promise<List>;
    privatePostAuthRFundingCredits (params?: {}): Promise<List>;
    privatePostAuthRFundingCreditsHist (params?: {}): Promise<List>;
    privatePostAuthRFundingCreditsSymbol (params?: {}): Promise<List>;
    privatePostAuthRFundingCreditsSymbolHist (params?: {}): Promise<List>;
    privatePostAuthRFundingTradesSymbolHist (params?: {}): Promise<List>;
    privatePostAuthRFundingTradesHist (params?: {}): Promise<List>;
    privatePostAuthRInfoFundingKey (params?: {}): Promise<List>;
    privatePostAuthRInfoUser (params?: {}): Promise<List>;
    privatePostAuthRSummary (params?: {}): Promise<List>;
    privatePostAuthRLoginsHist (params?: {}): Promise<List>;
    privatePostAuthRPermissions (params?: {}): Promise<List>;
    privatePostAuthWToken (params?: {}): Promise<List>;
    privatePostAuthRAuditHist (params?: {}): Promise<List>;
    privatePostAuthWTransfer (params?: {}): Promise<List>;
    privatePostAuthWDepositAddress (params?: {}): Promise<List>;
    privatePostAuthWDepositInvoice (params?: {}): Promise<List>;
    privatePostAuthWWithdraw (params?: {}): Promise<List>;
    privatePostAuthRMovementsCurrencyHist (params?: {}): Promise<List>;
    privatePostAuthRMovementsHist (params?: {}): Promise<List>;
    privatePostAuthRAlerts (params?: {}): Promise<List>;
    privatePostAuthWAlertSet (params?: {}): Promise<List>;
    privatePostAuthWAlertPriceSymbolPriceDel (params?: {}): Promise<List>;
    privatePostAuthWAlertTypeSymbolPriceDel (params?: {}): Promise<List>;
    privatePostAuthCalcOrderAvail (params?: {}): Promise<List>;
    privatePostAuthWSettingsSet (params?: {}): Promise<List>;
    privatePostAuthRSettings (params?: {}): Promise<List>;
    privatePostAuthWSettingsDel (params?: {}): Promise<List>;
    privatePostAuthRPulseHist (params?: {}): Promise<List>;
    privatePostAuthWPulseAdd (params?: {}): Promise<List>;
    privatePostAuthWPulseDel (params?: {}): Promise<List>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
